// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__n1jFU","info":"Panel_info__mpWpv","btns":"Panel_btns__ZX-id","button":"Panel_button__jqv2U"};